export class CreateInspectionInstanceError extends Error {
  constructor(message: string = 'Failed to create inspection instance') {
    super(message);
    this.name = 'CreateInspectionInstanceError';
  }
}
